import { Component, RefObject, createRef } from 'react'

import classnames from 'classnames'
import { withTranslation } from 'react-i18next'

import { Controller, IProps, IState } from './controller'

import ChatMessage from 'modules/chat/components/chatMessage'
import TriggerRenderer from 'modules/trigger/components/triggerRenderer'
import ButtonNewMessages from 'modules/chat/components/buttonNewMessages'
import ChatFooter from 'modules/chat/components/chatFooter'

import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'

export class Chat extends Component<IProps, IState> {
  chatBody: RefObject<HTMLDivElement>
  controller: Controller
  static whyDidYouRender = true

  constructor(props: IProps) {
    super(props)
    this.controller = new Controller(this)
    this.chatBody = createRef()
  }

  componentDidMount() {
    const {
      throttledVerifyPositionScroll,
      resizeListener
    } = this.controller

    window.addEventListener('scroll', throttledVerifyPositionScroll, true)
    window.addEventListener('resize', resizeListener, true)

    this.controller.setupChat()
  }

  render() {
    const {
      sendMessage,
      onChangeInput,
      onKeyPress,
      addEmoji,
      scrollToBottom,
      replyMessage,
      onClickMessage,
      removeReplyMessage
    } = this.controller

    const {
      messages,
      textInput,
      scrollInBottom,
      reply,
      showMessageOrigin,
      maxRows
    } = this.state

    const { hide, isMobile } = this.props

    const classes = classnames('chat-container', { 'is-hidden': hide })

    return (
      <div className={classes} data-test="chat-container">
        {!isMobile && (
          <div className="triggers-container">
            <TriggerRenderer />
          </div>
        )}

        {!hide
          && (
            <div
              className={classnames('chat-body', { 'chat-mobile': isMobile })}
              id="chatbox" ref={this.chatBody}>
              {
                messages?.map(messagesBatch => (
                  <div key={`container-${messagesBatch[0].messageId}`}>
                    {messagesBatch.map(message => (
                      <ChatMessage
                        key={message.messageId}
                        message={message}
                        onReplyRequest={replyMessage}
                        onReplyClick={onClickMessage}
                        active={showMessageOrigin === message.messageId}
                        isMobile={isMobile}/>
                    ))}
                  </div>
                )
                )
              }
            </div>
          )}

        <ButtonNewMessages hidden={scrollInBottom} onClick={scrollToBottom} />
        <ChatFooter
          reply={reply}
          removeReplyMessage={removeReplyMessage}
          addEmoji={addEmoji}
          sendMessage={sendMessage}
          textInput={textInput}
          maxRows={maxRows}
          onChangeInput={onChangeInput}
          onKeyPress={onKeyPress} />
      </div>
    )
  }

  componentWillUnmount() {
    const {
      throttledVerifyPositionScroll,
      resizeListener,
      removeChatEventListner
    } = this.controller

    window.removeEventListener('scroll', throttledVerifyPositionScroll, true)
    window.removeEventListener('resize', resizeListener, true)

    removeChatEventListner()
  }
}

export default withTranslation()(Chat)
